export default __webpack_public_path__ + "static/media/gallery - cover_03.cd601aa8.jpg";